import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
    PERFIL_ADMIN,
    getAdminEmpresa,
    getGestorEmpresa
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import buscarAdesaoPontoPorEmpresa from '../../actions/adesao-pontos/buscarAdesaoPontoPorEmpresa';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import buscarClientesPorEmpresa from '../../actions/adesao-pontos/buscarClientesEmpresa';

export class MenuAdesaoPontosEmpresa extends Component {

    render() {
        return (
            <div className="area-home">
                <Titulo texto="Adesão de pontos" urlRetorno="/gestao-empresa"/>
                <div className="row sistemas">
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                        getGestorEmpresa(this.props.empresaSelecionada.id),
                        getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-cadastro-configuracao-consumo-ponto"
                                  onClick={() => this.props.buscarAdesaoPontoPorEmpresa(this.props.empresaSelecionada.id)}>
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <i className="material-icons custom-icons">&#xe8b6;</i>
                                        <h5 className='nm-longo-resize-min'>
                                            Configuração consumo de pontos
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-gerenciar-clientes-empresa"
                                  onClick={() => this.props.buscarClientesPorEmpresa(this.props.empresaSelecionada.id)}>
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <i className="material-icons custom-icons"><PeopleAltOutlinedIcon className='css-icon' /></i>
                                        <h5 className='nm-longo-resize-min'>
                                            Lista de Clientes
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Autorizacao>
                </div>
            </div>
        )
    }
}


export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication
    }
}


export default withRouter(connect(mapStateToProps, {
    buscarAdesaoPontoPorEmpresa,
    buscarClientesPorEmpresa
})(MenuAdesaoPontosEmpresa));